export const PUBLIC_JOB_DETAIL_URL = '/publicJob/DetailsJson';

export const SalaryType = {
	Negotiable: 432,
	PerHour: 433,
	PerWeek: 434,
	Per4Weeks: 435,
	PerMonth: 436,
} as const;
